
/**
 * @roxi/routify 2.18.8
 * File generated Thu May 14 2026 11:42:44 GMT+0200 (Central European Summer Time)
 */

export const __version = "2.18.8"
export const __timestamp = "2026-05-14T09:42:44.655Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isPage": true,
      "ownMeta": {
        "query-params-is-page": true
      },
      "meta": {
        "query-params-is-page": true,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/:id",
      "id": "__id",
      "component": () => import('../src/pages/[id].svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "children": [
        {
          "isPage": true,
          "path": "/admin/ciselniky",
          "id": "_admin_ciselniky",
          "component": () => import('../src/pages/admin/ciselniky.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/emailsablony",
          "id": "_admin_emailsablony",
          "component": () => import('../src/pages/admin/emailsablony.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/emaily",
          "id": "_admin_emaily",
          "component": () => import('../src/pages/admin/emaily.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/historie",
          "id": "_admin_historie",
          "component": () => import('../src/pages/admin/historie.svelte').then(m => m.default)
        },
        {
          "isDir": true,
          "ext": "",
          "children": [
            {
              "isPage": true,
              "path": "/admin/jednotky/:id",
              "id": "_admin_jednotky__id",
              "component": () => import('../src/pages/admin/jednotky/[id].svelte').then(m => m.default)
            },
            {
              "isPage": true,
              "path": "/admin/jednotky/create",
              "id": "_admin_jednotky_create",
              "component": () => import('../src/pages/admin/jednotky/create.svelte').then(m => m.default)
            },
            {
              "isIndex": true,
              "isPage": true,
              "path": "/admin/jednotky/index",
              "id": "_admin_jednotky_index",
              "component": () => import('../src/pages/admin/jednotky/index.svelte').then(m => m.default)
            }
          ],
          "path": "/admin/jednotky"
        },
        {
          "isPage": true,
          "path": "/admin/mcp-tokeny",
          "id": "_admin_mcpTokeny",
          "component": () => import('../src/pages/admin/mcp-tokeny.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/migrate",
          "id": "_admin_migrate",
          "component": () => import('../src/pages/admin/migrate.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/nastaveni",
          "id": "_admin_nastaveni",
          "component": () => import('../src/pages/admin/nastaveni.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/osoby",
          "id": "_admin_osoby",
          "component": () => import('../src/pages/admin/osoby.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/plans",
          "id": "_admin_plans",
          "component": () => import('../src/pages/admin/plans.svelte').then(m => m.default)
        },
        {
          "isPage": true,
          "path": "/admin/pracoviste",
          "id": "_admin_pracoviste",
          "component": () => import('../src/pages/admin/pracoviste.svelte').then(m => m.default)
        }
      ],
      "isLayout": true,
      "path": "/admin",
      "id": "_admin__layout",
      "component": () => import('../src/pages/admin/_layout.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/administrace",
      "id": "_administrace",
      "component": () => import('../src/pages/administrace.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isFallback": true,
          "path": "/hodnotitel/_fallback",
          "id": "_hodnotitel__fallback",
          "component": () => import('../src/pages/hodnotitel/_fallback.svelte').then(m => m.default)
        }
      ],
      "path": "/hodnotitel"
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/hodnotitelold/:id",
          "id": "_hodnotitelold__id",
          "component": () => import('../src/pages/hodnotitelold/[id].svelte').then(m => m.default)
        },
        {
          "isIndex": true,
          "isPage": true,
          "path": "/hodnotitelold/index",
          "id": "_hodnotitelold_index",
          "component": () => import('../src/pages/hodnotitelold/index.svelte').then(m => m.default)
        }
      ],
      "path": "/hodnotitelold"
    },
    {
      "isIndex": true,
      "isPage": true,
      "ownMeta": {
        "query-params-is-page": true
      },
      "meta": {
        "query-params-is-page": true,
        "recursive": true,
        "preload": false,
        "prerender": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/nahlizejici/:id",
          "id": "_nahlizejici__id",
          "component": () => import('../src/pages/nahlizejici/[id].svelte').then(m => m.default)
        }
      ],
      "path": "/nahlizejici"
    },
    {
      "isPage": true,
      "path": "/nahlizejici",
      "id": "_nahlizejici",
      "component": () => import('../src/pages/nahlizejici.svelte').then(m => m.default)
    },
    {
      "isDir": true,
      "ext": "",
      "children": [
        {
          "isPage": true,
          "path": "/plan/:id",
          "id": "_plan__id",
          "component": () => import('../src/pages/plan/[id].svelte').then(m => m.default)
        }
      ],
      "path": "/plan"
    },
    {
      "isPage": true,
      "path": "/referent",
      "id": "_referent",
      "component": () => import('../src/pages/referent.svelte').then(m => m.default)
    },
    {
      "isPage": true,
      "path": "/vystupy",
      "id": "_vystupy",
      "component": () => import('../src/pages/vystupy.svelte').then(m => m.default)
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => import('../src/pages/_layout.svelte').then(m => m.default)
}


export const {tree, routes} = buildClientTree(_tree)

